$(window).load(function () {
    let txt = '<div id="shopify-section-api-cart-items" class="shopify-section"><div data-api-content>\n' +
        '  <div class="cart__items cartList">\n' +
        '    \n' +
        '</div>\n' +
        '</div>\n' +
        '</div>';

    setTimeout(function () {
        $("#SI_trigger").replaceWith(`<span class="btn btn--full btn--large btn--clear" href="#" id="SI_trigger" style="display: flex;"><img
            style="width:38px; height: 45px; margin-right: 15px; margin-top: -12px; margin-left: -33px;"
            src="https://cdn.shopify.com/s/files/1/2713/5040/files/notify-me_bc8bf4c9-2d96-463a-9112-196528dcd70b.gif?v=1646143610">EMAIL WHEN IN STOCK</span>`);
        $("#SI_trigger").css("display", "flex");
        $("#admin-bar-iframe").remove();
    }, 1000)
});
let start = 0;

function showLoading() {
    const cartList = $('.cart__items.cartList');
    // cartList.hide()
    $('.custom-loadbar').show();
    // $('.loading-cart').show();
    hideQuantity()
    $("input[data-quantity-input]").attr("disabled","disabled");
}

function hideLoading() {
    const cartList = $('.cart__items.cartList');
    setTimeout(function (){
        $('.custom-loadbar').hide();

    },1200)
    // $('.loading-cart').hide();
    setTimeout(function (){
        cartList.show();
    },100)
    $("input[data-quantity-input]").removeAttr("disabled");
}

function hideQuantity() {
    if (localStorage.getItem('storedFreeItem')) {
        let free = localStorage.getItem('storedFreeItem');
        $('.p-item-' + free).find('.quantity__wrapper').hide();
        convertToFreeItem(free)
        hideLoading();

        setTimeout(function () {
            $('.p-item-' + free).find('.quantity__wrapper').hide();
        }, 900);
        setTimeout(function () {
            $('.p-item-' + free).find('.quantity__wrapper').hide();
        }, 1000);
        setTimeout(function () {
            $('.p-item-' + free).find('.quantity__wrapper').hide();
        }, 2000);
        setTimeout(function () {
            $('.p-item-' + free).find('.quantity__wrapper').hide();
        }, 4000);

        setTimeout(function () {
            convertToFreeItem(free)
        }, 1000);
        setTimeout(function () {
            convertToFreeItem(free)
        }, 2000);
        setTimeout(function () {
            convertToFreeItem(free)
        }, 4000);
    }
    setTimeout(function () {
        $('.cart__items__quantity').css('visibility', 'visible')
    }, 1000);
    setTimeout(function () {
        $('.cart__items__quantity').css('visibility', 'visible')
    }, 2000);
    setTimeout(function () {
        $('.cart__items__quantity').css('visibility', 'visible')
    }, 4000);
}

function convertToFreeItem(free) {
    let spn = $('.p-item-' + free).find('.line__price span');
    let del = $('.p-item-' + free).find('.line__price del');
    let mark = $('.p-item-' + free).find('.line__price mark');

    let txt = spn.text();
    del.remove();
    mark.remove();
    spn.hide().after('<mark>£0.00</mark>').after('<del>' + txt + '</del>');
    $('.p-item-' + free).find('.cart__items__total').empty().append('£0.00')
    $('.p-item-' + free).find('a').attr("href","#")
}

function removeItem(variant_id, action = '') {
    /*console.log('removeItem process started')*/
    // console.log('RemoveItem process started -> ID:' + variant_id)
    showLoading();
    $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        data: {
            id: variant_id,
            quantity: 0,
        },
    }).then((data) => {
        if (localStorage.getItem("storedFreeItem") === variant_id) {
            localStorage.removeItem("storedFreeItem");
            localStorage.removeItem("storedDiscount");
        }
      const sanitazide =  variant_id.split(':')
const item = document.querySelector(`[data-product-id="${sanitazide[0]}"]`)?.closest(".cart__items__row");
      console.log("itemtoremove",item,variant_id)
      if(item){
        item.remove();
      }
        setTimeout(function () {
             console.log("Items removed-> loadForm action");
           
                loadForm();
            
        }, 1000)
    });
}

function updateQuantity(variant_id, action, quantity) {
    showLoading()
    let new_quantity = "";
    if (action === "increase") {
        new_quantity = quantity + 1;
    } else if (action === "decrease") {
        new_quantity = quantity - 1;
    } else if (action === "change") {
        new_quantity = quantity;
    }
    $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        data: {
            id: variant_id,
            quantity: new_quantity
        },
    }).then((data) => {
        if (localStorage.getItem("storedFreeItem") === variant_id) {
            localStorage.removeItem("storedFreeItem");
            localStorage.removeItem("storedDiscount");
        }
        setTimeout(function () {
            // console.log("Items updated-> loadForm action");
            if (action !== "") {
                loadForm();
                if (action === 'refresh') {
                    loadForm();
                }
            } else {
                loadForm();
            }
        }, 1000)
    });
}

function hideErrors() {
    $('.errors').slideUp()
}

function loadForm() {
    // console.log('loadForm');
    hideErrors();
    hideQuantity()
    hideLoading()
    window
        .fetch(`${window.theme.routes.root_url}?section_id=api-cart-items`)
        .then((response) => {
            return response.text();
        })
        .then((response) => {
           

            // console.log("test load form repsonse")
            if (!response.includes("cart__items__grid")) {
                $("div[data-cart-empty]").removeClass("cart--hidden");
                $('div[data-line-items]').empty()
                $('div.drawer__bottom').addClass("cart--hidden")
                if ($('div[data-cart-form]').length > 0) {
                    $('div[data-cart-form]').addClass("cart--hidden")
                }
                $(".loading-cart").hide();
                $(".cart__message.is-success").hide();
            } else {
                // console.log("more than 1 item in your cart")
                $("div[data-cart-empty]").addClass("cart--hidden");
                $('div.drawer__bottom').removeClass("cart--hidden")
                $(".cart__message.is-success").show();
                if ($('div[data-cart-form]').length > 0) {
                    $('div[data-cart-form]').removeClass("cart--hidden")
                }
                const fresh = document.createElement('div');
                fresh.innerHTML = response;
                const lineItems = $(fresh).find('.cart__items__grid');
                console.log("-> lineItems", lineItems);
                 //find stored items, remove not matched and store rest
                const storedItems = localStorage.getItem('storedItems');
                const parsedItems = JSON.parse(storedItems);
                const tempCodes = [];
                lineItems.each((index, item) => {
                    console.log("-> item", item);  
                    const checkItem = $(item).attr('data-product-id')
                    console.log("-> checkItem", checkItem);
                    //if checkItem is equal to stored item push to tempCodes
                    if(parsedItems.length !== 0 && parsedItems !== null){
                        parsedItems.forEach(item => {
                            if(item.relatedProduct === checkItem){
                                tempCodes.push(item);
                                console.log("-> tempCodes", tempCodes);
                            }
                        })
                    }
                    console.log("selam")
                   
                })
                // set local storage
                localStorage.setItem('storedItems', JSON.stringify(tempCodes));
                console.log("-> fresh", localStorage.getItem('storedItems'))
                    

                // console.log("-> fresh", fresh);
                $('div[data-line-items]').html(fresh)
                $('.cartList').hide();
                hideQuantity()
                $('.cart__items__quantity').css('visibility', 'visible')
                updateTotal()
                hideLoading()
                hideErrors();
            }

        }).catch((err) => {
        hideQuantity();
    });

}

function updateTotal() {
    window
        .fetch(`${window.theme.routes.cart}.js`)
        .then(this.handleErrors)
        .then((response) => {
            return response.json();
        })
        .then((response) => {
            let cart = response;
            /*console.log("-> cart", cart);*/
            if (cart) {
                console.log("-> cart.total_price", cart.total_price);
                let temporaryPrice = cart.total_price;
                if (localStorage.getItem('storedItems')) {
                   
                    JSON.parse(localStorage.getItem('storedItems')).forEach(item => {
                    // console.log("-> '.p-item-' + free", '.p-item-' + free);
                    if($('.p-item-' + item.storedFreeItem).length > 0){
                      const priceChild = $('.p-item-' + item.storedFreeItem).attr('data-product-price');
                      console.log("-> priceChild", item.storedFreeItem);
                      temporaryPrice = temporaryPrice - priceChild;
                    }
                })
                                  console.log("temppppppp",temporaryPrice)

                    
                }
                const price = formatMoney(temporaryPrice);
                $('.gt-final-price').empty().val(temporaryPrice / 100)
                $('span[data-cart-final]').empty().html(price)
                $('.cart__footer__value').empty().html(price)
                

            }
        })
        .catch((e) => {
            console.error(e);
        });

}


function formatMoney(cents, format) {
    window.theme = window.theme || {};
    if (typeof cents == 'string') {
        cents = cents.replace('.', '');
    }
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || theme.moneyFormat || '${{ amount }}');

    var defaultOption = function (opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    var formatWithDelimiters = function (number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) {
            return 0;
        }
        ;

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.');
        var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var cents = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
}
